import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=3b4303e0&"
import script from "./loyalty.vue?vue&type=script&lang=js&"
export * from "./loyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports